import React from "react";
import { ArchiveIcon, DocumentIcon } from "evergreen-ui";

const InvoiceLedgerSwitch = ({ value, onChange }) => <nav className="is2-invoice-ledger-switch" aria-label="Invoice ledger">
  <button type="button" className={value === "sales" ? "is-active" : ""} aria-current={value === "sales" ? "page" : undefined} onClick={() => onChange("sales")}>
    <DocumentIcon size={15} />
    <span><strong>Sales invoices</strong><small>Invoices issued to customers</small></span>
  </button>
  <button type="button" className={value === "purchases" ? "is-active" : ""} aria-current={value === "purchases" ? "page" : undefined} onClick={() => onChange("purchases")}>
    <ArchiveIcon size={15} />
    <span><strong>Purchase invoices</strong><small>Supplier invoices and receipts</small></span>
  </button>
</nav>;

export default InvoiceLedgerSwitch;
